import React from 'react'
import { useOrder } from '../context/OrderContext'

const OrderSummary: React.FC = () => {
  const { draft, computeTotal } = useOrder()
  const total = computeTotal()

  return (
    <div
      className="card order-summary-box"
      style={{
        background: 'var(--tun-card-bg)',
        padding: "1rem",
        borderRadius: "1rem",
        border: "1px solid rgba(255,255,255,0.1)",
        color: 'var(--tun-card-text)',
      }}
    >
      <h2 style={{ fontWeight: 700, fontSize: "1rem", marginBottom: ".75rem" }}>
        🧾 Récapitulatif
      </h2>

      <div style={{ fontSize: ".9rem", lineHeight: 1.5 }}>
        {/* SERVICE */}
        {draft.service && (
          <p>
            <strong>Service :</strong> {draft.service.name}
            {" — "}{draft.service.base_price} CHF
          </p>
        )}

        {/* OPTION */}
        {draft.option && (
          <p>
            <strong>Option :</strong> {draft.option.label}
            {" — "}{draft.option.price_delta} CHF
          </p>
        )}

        {/* OWNER */}
        {draft.racketOwnerName && (
          <p>
            <strong>Propriétaire :</strong> {draft.racketOwnerName}
          </p>
        )}

        {/* RACKET */}
        {draft.racketBrand && (
          <p>
            <strong>Raquette :</strong> {draft.racketBrand}
            {draft.racketDescription && ` — ${draft.racketDescription}`}
          </p>
        )}

        {/* TENSIONS */}
        {(draft.tensionVertical || draft.tensionHorizontal) && (
          <p>
            <strong>Tension :</strong> {draft.tensionVertical} / {draft.tensionHorizontal} kg
          </p>
        )}

        {/* PICKUP */}
        {draft.pickupMode && (
          <p>
            <strong>Prise en charge :</strong> {draft.pickupMode.label}
            {draft.pickupAddress && ` — ${draft.pickupAddress}`}
            <br />

            <span style={{ color: "#22c55e" }}>
              Prix prise en charge :{" "}
              {/* 🟢 Prix FIXE */}
              {draft.pickupMode.pricing_mode === "FIXED" && (
                `${draft.pickupMode.fixed_price?.toFixed(2) ?? "0.00"} CHF`
              )}

              {/* 🟢 Prix au KM */}
              {draft.pickupMode.pricing_mode === "PER_KM" && (
                draft.pickupPrice != null
                  ? `${draft.pickupPrice.toFixed(2)} CHF`
                  : "—"
              )}
            </span>
          </p>
        )}

        {/* DELIVERY */}
        {draft.deliveryMode && (
          <p>
            <strong>Livraison :</strong> {draft.deliveryMode.label}
            {draft.deliveryAddress && ` — ${draft.deliveryAddress}`}
            <br />

            <span style={{ color: "#22c55e" }}>
              Frais de livraison :{" "}

              {/* Prix fixés */}
              {draft.deliveryMode.pricing_mode === "FIXED" && (
                `${draft.deliveryMode.fixed_price?.toFixed(2) ?? "0.00"} CHF`
              )}

              {/* Prix au km */}
              {draft.deliveryMode.pricing_mode === "PER_KM" && (
                draft.deliveryPrice != null
                  ? `${draft.deliveryPrice.toFixed(2)} CHF`
                  : "—"
              )}
            </span>
          </p>
        )}
      </div>

      {/* TOTAL */}
      <div
        data-testid="order-summary-total"
        style={{
          borderTop: "1px solid rgba(255,255,255,0.15)",
          marginTop: "1rem",
          paddingTop: "1rem",
          fontWeight: 700,
          color: "#22c55e",
        }}
      >
        Total estimé : {total.toFixed(2)} CHF
      </div>
    </div>
  )
}

export default OrderSummary
